<div class="register_verification_container">
	<div class="row">
		<div class="col-12">
			<div class="header">
				<img class="image-11" src="../assets/newimg/image-11-86@2x.png" alt="image 11" />
				<div class="flex-col">
					<div class="overlap-group-1">
						<p class="surname opensans-bold-sapphire-20px">
							<span class="opensans-normal-sapphire-20px">Cross</span>
							<span class="ellipsis"></span>
							<span class="opensans-extra-bold-sapphire-20px">Easy</span>
						</p>
					</div>
					<p class="brought-to-you-by-cr opensans-normal-star-dust-9px">
						<span class="opensans-normal-star-dust-9px">
							Brought to you by Cross-Border Road and Transport
							Agency
						</span>
					</p>
				</div>
			</div>
		</div>
	</div>

	<div class="row content_row">
		<div class="col-8 verification_form">
			<div class="heading">
				<h1>Registration</h1>
			</div>
			<div class="verification_details">
				<p class="subheading">A
					verification link has been sent to your {{communicationType}}.</p>
				<p class="please-provide-us">
					Please click
					on the link that has been sent to your {{communicationType}} : {{value}} to verify and complete
					the registration process.
				</p>

				<div class="actions">
					<button *ngIf="showButton" (click)="resend()"
						class="btn btn-outline-warning">Resend verification link</button>
					<p *ngIf="showTimer">Resend activation link in {{timeLeft}} </p>
				</div>
			</div>
		</div>
		<div class="col-4 parent">
			<div class="parents">
				<div class="overlap_group">
					<div class="surname">
						<span class="cross">Cross</span>
						<span class="ellipsis"></span>
						<span class="easy">Easy</span>
						<div class="here-there-everywhere">
							<span class="opensans-normal-white-16px">Here, There, Everywhere</span>
						</div>
					</div>
				</div>
				<div class="convenient-effectiv">
					<p>Convenient, Effective and</p>
					<p>Secure way to apply and</p>
					<p>manage your Permits</p>
					<p>Online</p>
				</div>
			</div>
		</div>
	</div>
</div>